import React from 'react';
import $ from 'jquery';

import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';

import '../css/prices.css';


import contrato233 from '../media/CONTRATO PROFECO 3 servicios 233-2020.pdf';
import contrato270 from '../media/CONTRATO PROFECO 3 servicios 270-2020.pdf';
import contrato from '../media/Contrato Dish-ON REGISTRO 447-2025 - accesible.pdf';


const Prices = props =>
{


    return (
        <div id='prices' className='container-fluid p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h3>CONTRATO</h3>


                {/* <p><a href={contrato233} target='_blank'> Contrato registrado ante PROFECO: 233-2020</a></p> */}
                <p><a href={contrato} target='_blank'> Contrato de Adhesión de Telecomunicaciones ON Internet 447 - 2025</a></p>

               


               
               
            </TocPage>
        </div>
    );
}

export default Prices;



// WEBPACK FOOTER //
// ./src/components/Contratopostalfija.js